import http from "infra/http";
import { useMutation } from "react-query";

function useDeletarBloqueioUnidade() {
  return useMutation(
    `/v1/bloqueio-reserva`,
    (id: string) =>
       http.delete(`/v1/bloqueio-reserva/${id}`),
    { retry: false }
  );
}

export default useDeletarBloqueioUnidade;
